"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  1: { xs: 24 },
  2: { xs: 24, sm: 12 },
  3: { xs: 24, sm: 12, md: 8 },
  4: { xs: 24, sm: 12, md: 6 }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-pro/lib/DescriptionList/responsive.js
// module id = 4396
// module chunks = 0